// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"AssistantApp_fadeIn__38UgW","loader":"AssistantApp_loader__2QqX4","load3":"AssistantApp_load3__1tJPK"};